export default __webpack_public_path__ + "static/media/get-involved-icon.1e0efddc.svg";